<script type="ts">
  import type { CategoryConfig } from '../../modules/projects/project.interface';
  import type { Item } from '../../modules/item/item.interface';
  import { createEventDispatcher } from 'svelte';
  import { Row, Col, Button } from 'svelte-materialify';
  import { alert } from '../../store';
  import Files from '../../lib/files';
  import ItemInputsWithValidation from './ItemInputsWithValidation.svelte';
  import ItemPreview from './ItemPreview.svelte';
  import { ItemStatus } from '../../modules/item/item.constants';

  export let item: Item;
  export let categoryConfig: CategoryConfig;
  export let isEdit: boolean;
  export let statusAfterEdit: ItemStatus;
  export let isFeatured = false;

  const dispatch = createEventDispatcher();
  const files = new Files();
  let isValid = false;

  function validatedEvent(eventType: string, status?: ItemStatus) {
    if (!isValid) {
      alert.show('Please fill required fields!');
      return;
    }

    if (status) {
      item.status = status;
    }

    dispatch(eventType, { item, files });
  }

  function onFileAdded(event: { detail: File }) {
    const file = event.detail;
    files.add(file);
  }
</script>

{#if item && categoryConfig.key !== 'product'}
  <div>
    <Row>
      <Col cols={8}>
        <div class="d-flex justify-space-between">
          <h4 class="text-h4 mb-8">{categoryConfig.name}</h4>
          <slot name="header-actions" />
        </div>
        <ItemInputsWithValidation
          bind:item
          bind:isValid
          {categoryConfig}
          {isEdit}
          on:fileAdded={onFileAdded}
        />
      </Col>
      <Col class="ml-auto grey lighten-2" cols={3}>
        <ItemPreview {item} {categoryConfig} />
        {#if isEdit}
          <Button block class="amber mt-2 mb-2" on:click={() => validatedEvent('update')}>
            <span>Update</span>
            {#if statusAfterEdit}
              <span>&nbsp;&&nbsp; Add to {statusAfterEdit}</span>
            {/if}
          </Button>
        {:else if isFeatured}
          <Button
            block
            class="green white-text mt-2 mb-2"
            on:click={() => validatedEvent('create', ItemStatus.FEATURED)}>Save</Button
          >
          <Button
            on:click={() => validatedEvent('create', ItemStatus.FEATURED_DISABLED)}
            class="mt-2 mb-2"
            block>Save as Disabled</Button
          >
        {:else}
          <Button
            block
            class="green white-text mt-2 mb-2"
            on:click={() => validatedEvent('create', ItemStatus.REPORT)}
            >Add to Report</Button
          >
          <Button
            on:click={() => validatedEvent('create', ItemStatus.QUEUE)}
            class="mt-2 mb-2"
            block>Add to Queue</Button
          >
        {/if}
        <slot name="sidebar" />
      </Col>
    </Row>
  </div>
{:else}
  <div>
    <Row>
      <Col cols={9}>
        <iframe
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          title="iframe"
          style="width:100%; height:100%"
          src={item.url}
          frameborder="0"
        />
      </Col>
      <Col class="ml-auto grey lighten-4" cols={3}>
        <ItemPreview {item} {categoryConfig} />
        <ItemInputsWithValidation
          bind:item
          bind:isValid
          {categoryConfig}
          {isEdit}
          on:fileAdded={onFileAdded}
        />
        {#if isEdit}
          <Button block class="amber mt-2 mb-2" on:click={() => validatedEvent('update')}>
            <span>Update</span>
            {#if statusAfterEdit}
              <span>&nbsp;&&nbsp; Add to {statusAfterEdit}</span>
            {/if}
          </Button>
        {:else}
          <Button
            block
            class="green white-text mt-2 mb-2"
            on:click={() => validatedEvent('create', ItemStatus.REPORT)}
            >Add to Report</Button
          >
          <Button
            on:click={() => validatedEvent('create', ItemStatus.QUEUE)}
            class="mt-2 mb-2"
            block>Add to Queue</Button
          >
        {/if}
        <slot name="sidebar" />
      </Col>
    </Row>
  </div>
{/if}

<style lang="scss">
  :global(.s-row) {
    overflow: hidden;
  }

  :global(.s-col) {
    overflow-y: auto !important;
    max-height: calc(100vh - 120px);
  }
</style>
